/* ABSCENTS v138 · filtros de tienda (colecciones y búsqueda).
   Lee los datos de [data-abx-col-datos] (snippets/abx-col-datos.liquid), pinta pestañas, chips, lateral y hojas,
   y carga cada cambio por Section Rendering (?section_id=) sin recargar. Etiquetas con lógica Y (Search & Discovery). */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-abx-col]');
  if (!raiz || raiz.__abx) return;
  raiz.__abx = 1;
  var SEC = raiz.getAttribute('data-section-id');
  var RUTA = location.pathname;
  var FAMS = ['AMADERADO', 'CÍTRICO', 'AROMÁTICO', 'AVAINILLADO', 'AFRUTADO', 'CALIDO ESPECIADO', 'DULCE', 'FLORAL', 'FLORAL BLANCO', 'ÁMBAR', 'ROSA', 'CUERO', 'ALMIZCLE', 'ATALCADO', 'FRESCO ESPECIADO', 'OUD', 'VERDE', 'MARINO', 'TABACO', 'IRIS', 'ALMENDRADO', 'CEREZA', 'TROPICAL', 'LAVANDA', 'CAFÉ', 'COCO', 'AHUMADO', 'ACUÁTICO', 'TERROSO', 'OZONICO', 'CARAMELO'];
  var G = {
    cat: [['COMERCIAL', 'Diseñador'], ['NICHO', 'Nicho'], ['DUPES', 'Árabes']],
    conc: [['EAU DE PARFUM', 'Eau de parfum'], ['EXTRAIT DE PARFUM', 'Extrait de parfum'], ['EAU DE TOILETTE', 'Eau de toilette'], ['PARFUM', 'Parfum'], ['EAU DE COLOGNE', 'Eau de cologne'], ['PARFUM COLOGNE', 'Parfum cologne']],
    gen: [['HOMBRE', 'Hombre y unisex'], ['MUJER', 'Mujer']],
    dest: [['BEST SELLER', 'Más vendidos'], ['NUEVO', 'Nuevos']]
  };
  var CATL = { COMERCIAL: 'D', NICHO: 'N', DUPES: 'A' };
  var BQ = 'EN BOUTIQUE';
  var PRECIOS = [80, 120, 180, 250];
  var ORD = { 'relevance': 'Relevancia', 'manual': 'Destacados', 'best-selling': 'Más vendidos', 'created-descending': 'Recién llegados', 'price-ascending': 'Precio: menor a mayor', 'price-descending': 'Precio: mayor a menor', 'title-ascending': 'Nombre: A–Z' };
  var ORD_LISTA = ['relevance', 'manual', 'best-selling', 'created-descending', 'price-ascending', 'price-descending', 'title-ascending'];
  var mqD = window.matchMedia('(min-width: 990px)');
  var mqT = window.matchMedia('(min-width: 769px)');
  var D = null, EX = {}, CACHE = {}, hoja = '', hojaPintada = '', seq = 0, qCasa = '', subirAlCerrar = false, topeCasas = false;
  var hojaEl = raiz.querySelector('[data-abx-hoja]');
  if (hojaEl) document.body.appendChild(hojaEl);
  function mio(b) { return b && (raiz.contains(b) || (hojaEl && hojaEl.contains(b))); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fmt(n) { return Number(n || 0).toLocaleString('es-MX'); }
  function fmtN(n) { return D && D.tipo === 's' && n >= 1000 ? '1,000+' : fmt(n); }
  function dec(s) { return String(s || '').replace(/&amp;/g, '&').replace(/&#39;|&#x27;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, '<').replace(/&gt;/g, '>'); }
  var COMPLETAS = { 'todos-los-perfumes': '', 'nicho-1': 'N', 'disenador': 'D', 'perfumes-arabes': 'A' };
  function nom(s) { return String(s || '').normalize('NFD').replace(/\p{M}/gu, '').toUpperCase(); }
  function famNom(f) { if (f === 'CALIDO ESPECIADO') return 'Cálido especiado'; if (f === 'OZONICO') return 'Ozónico'; var s = f.toLowerCase(); return s.charAt(0).toUpperCase() + s.slice(1); }
  function perf(n) { return n === 1 ? '1 perfume' : fmt(n) + ' perfumes'; }
  function params() { var p = new URLSearchParams(location.search); p.delete('section_id'); return p; }
  function tags(p) { return (p || params()).getAll('filter.p.tag'); }
  function enGrupo(k, t) { return G[k].some(function (o) { return o[0] === t; }); }
  function grupoDe(t) { for (var k in G) if (enGrupo(k, t)) return k; if (FAMS.indexOf(t) >= 0) return 'fam'; if (t === BQ) return 'bq'; return ''; }
  function etiqueta(k, t) { var o = G[k].filter(function (x) { return x[0] === t; })[0]; return o ? o[1] : t; }
  function activo(k, p) { var ts = tags(p); for (var i = 0; i < G[k].length; i++) if (ts.indexOf(G[k][i][0]) >= 0) return G[k][i][0]; return ''; }
  function conTags(p, ts) { p.delete('filter.p.tag'); ts.forEach(function (t) { p.append('filter.p.tag', t); }); return p; }
  function urlDe(p, conPagina) { if (!conPagina) p.delete('page'); p.delete('section_id'); var s = p.toString(); return RUTA + (s ? '?' + s : ''); }
  function lte() { var v = params().get('filter.v.price.lte'); return v ? Number(v) : 0; }

  /* ---------- acciones ---------- */
  function radio(k, v) { var p = params(), act = activo(k, p); var ts = tags(p).filter(function (t) { return !enGrupo(k, t); }); if (v && v !== act) ts.push(v); ir(urlDe(conTags(p, ts))); }
  function alternar(t) { var p = params(), ts = tags(p), i = ts.indexOf(t); if (i >= 0) ts.splice(i, 1); else ts.push(t); ir(urlDe(conTags(p, ts))); }
  function casa(v) { var p = params(), act = p.get('filter.p.vendor'); p.delete('filter.p.vendor'); if (v && v !== act) p.append('filter.p.vendor', v); ir(urlDe(p)); }
  function precio(v) { var p = params(), act = lte(); p.delete('filter.v.price.lte'); p.delete('filter.v.price.gte'); v = Number(v) || 0; if (v && v !== act) p.set('filter.v.price.lte', v); ir(urlDe(p)); }
  function orden(v) { var p = params(); if (v === D.ordenDef) p.delete('sort_by'); else p.set('sort_by', v); ir(urlDe(p)); }
  function limpiar() { var p = params(); Array.from(p.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0) p.delete(k); }); ir(urlDe(p)); }
  function quitarParam(k) { var p = params(); p.delete(k); ir(urlDe(p)); }

  /* ---------- carga ---------- */
  function ir(url, subir) { cargar(url, true, !!subir); }
  function cargar(url, push, subir) {
    var id = ++seq;
    if (push) { try { history.pushState({ abxCol: 1 }, '', url); } catch (e) {} }
    raiz.classList.add('is-cargando');
    pintar();
    var u = new URL(url, location.origin);
    u.searchParams.set('section_id', SEC);
    fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      if (id !== seq) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var nuevo = doc.getElementById('CollectionAjaxContent');
      var cont = document.getElementById('CollectionAjaxContent');
      if (!nuevo || !cont) { location.href = url; return; }
      cont.innerHTML = nuevo.innerHTML;
      raiz.classList.remove('is-cargando');
      montar(subir);
      document.dispatchEvent(new CustomEvent('collection:reloaded'));
    }).catch(function () { if (id === seq) location.href = url; });
  }
  function leer() {
    var s = raiz.querySelector('[data-abx-col-datos]');
    if (!s) return null;
    var d; try { d = JSON.parse(s.textContent); } catch (e) { return null; }
    d.tagMap = {}; (d.tags || []).forEach(function (t) { t[0] = dec(t[0]); d.tagMap[t[0]] = t[1]; });
    (d.casas || []).forEach(function (c) { c[0] = dec(c[0]); });
    return d;
  }
  /* vista que elige el cliente: un perfume, cuadrícula o lista (se recuerda en el navegador) */
  var VISTAS = [
    ['uno', 'Un perfume', '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="16" height="16"/></svg>'],
    ['cuadricula', 'Cuadrícula', '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="7" height="7"/><rect x="13" y="4" width="7" height="7"/><rect x="4" y="13" width="7" height="7"/><rect x="13" y="13" width="7" height="7"/></svg>'],
    ['lista', 'Lista', '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="5" width="16" height="3"/><rect x="4" y="10.5" width="16" height="3"/><rect x="4" y="16" width="16" height="3"/></svg>']
  ];
  function vistaActual() {
    var k = ''; try { k = localStorage.getItem('abx-vista') || ''; } catch (e) {}
    if (k !== 'uno' && k !== 'cuadricula' && k !== 'lista') k = mqT.matches ? 'cuadricula' : 'lista';
    return k;
  }
  function vista() {
    var g = raiz.querySelector('[data-abx-rejilla]'); if (!g) return;
    var k = vistaActual(), v = k === 'uno' ? 'large' : k === 'lista' ? 'list' : (mqD.matches ? 'small' : 'medium');
    if (g.getAttribute('data-view') !== v) { g.setAttribute('data-view', v); window.dispatchEvent(new Event('resize')); }
  }
  function ponerVista(k) { try { localStorage.setItem('abx-vista', k); } catch (e) {} vista(); pintarInfo(); }
  function vistasHtml() {
    var act = vistaActual();
    return '<div class="abx-col__vistas" role="group" aria-label="Vista">' + VISTAS.map(function (x) {
      return '<button type="button" class="abx-vb' + (x[0] === act ? ' is-on' : '') + '" data-act="vista" data-v="' + x[0] + '" aria-pressed="' + (x[0] === act) + '" aria-label="Vista: ' + x[1] + '" title="' + x[1] + '">' + x[2] + '</button>';
    }).join('') + '</div>';
  }
  function limpiarLigas() {
    raiz.querySelectorAll('a[data-abx-pag]').forEach(function (a) { var u = new URL(a.getAttribute('href'), location.origin); u.searchParams.delete('section_id'); u.searchParams.delete('view'); a.setAttribute('href', u.pathname + u.search); });
  }
  function montar(subir) {
    var d = leer(); if (!d) return;
    D = d; EX = {};
    vista(); limpiarLigas();
    if (D.cuentaTxt) document.querySelectorAll('[data-collection-count]').forEach(function (el) { el.textContent = D.cuentaTxt; });
    pintar();
    extras();
    if (hoja) { subirAlCerrar = subirAlCerrar || subir; return; }
    if (subir || window.scrollY > objetivo() + 4) arriba();
  }
  function extras() {
    if (!D.filtros) return;
    var mio = seq;
    Object.keys(G).forEach(function (k) {
      if (!activo(k)) return;
      var p = params(); p.delete('page'); p.delete('sort_by');
      conTags(p, tags(p).filter(function (t) { return !enGrupo(k, t); }));
      p.set('view', 'abxconteo');
      var url = RUTA + '?' + p.toString();
      var listo = function (j) { if (mio !== seq || !j) return; EX[k] = j; pintar(); };
      if (CACHE[url]) { listo(CACHE[url]); return; }
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        var m = {}; (j.g || []).forEach(function (x) { m[x[0]] = x[1]; });
        CACHE[url] = { t: j.t || 0, m: m }; listo(CACHE[url]);
      }).catch(function () {});
    });
  }

  /* ---------- scroll ---------- */
  var pegajoso = null;
  var cabeza = document.querySelector('.site-header');
  function tope() {
    if (!pegajoso) {
      var n = cabeza;
      while (n && n !== document.body) { var ps = getComputedStyle(n).position; if (ps === 'sticky' || ps === 'fixed') { pegajoso = n; break; } n = n.parentElement; }
    }
    if (!pegajoso || !cabeza) return 0;
    var b = Math.min(cabeza.getBoundingClientRect().bottom, pegajoso.getBoundingClientRect().bottom);
    return b > 0 ? Math.round(b) : 0;
  }
  function objetivo() { var a = raiz.querySelector('[data-abx-ancla]'); if (!a) return 0; return Math.max(0, Math.round(a.getBoundingClientRect().top + window.scrollY - tope() - (mqD.matches ? 16 : 0))); }
  function arriba() { window.scrollTo({ top: objetivo(), behavior: 'auto' }); }
  var rafT = 0;
  function medir() { rafT = 0; raiz.style.setProperty('--abx-top', tope() + 'px'); }
  window.addEventListener('scroll', function () { if (!rafT) rafT = requestAnimationFrame(medir); }, { passive: true });
  window.addEventListener('resize', function () { if (!rafT) rafT = requestAnimationFrame(medir); });
  if (cabeza && window.ResizeObserver) new ResizeObserver(function () { if (!rafT) rafT = requestAnimationFrame(medir); }).observe(cabeza);

  /* ---------- modelos ---------- */
  function fuente(k) { return activo(k) ? EX[k] : { t: D.total, m: D.tagMap }; }
  function pestanas() {
    var act = activo('cat'), src = fuente('cat');
    var l = [{ v: '', l: 'Todos', n: src ? src.t : null, on: !act }];
    G.cat.forEach(function (o) { var n = src ? (src.m[o[0]] || 0) : null; if (n === 0 && act !== o[0]) return; l.push({ v: o[0], l: o[1], n: n, on: act === o[0] }); });
    var ver = !!D.filtros && (act ? true : l.length > 2);
    return { ver: ver, l: l };
  }
  function opciones(k) {
    var act = activo(k), src = fuente(k);
    return G[k].map(function (o) { return { v: o[0], l: o[1], n: src ? (src.m[o[0]] || 0) : null, on: act === o[0] }; }).filter(function (x) { return x.on || x.n === null || x.n > 0; });
  }
  function familias() {
    var ts = tags();
    return FAMS.filter(function (f) { return D.tagMap[f] > 0 || ts.indexOf(f) >= 0; }).map(function (f) { return { v: f, l: famNom(f), n: D.tagMap[f] || 0, on: ts.indexOf(f) >= 0 }; }).sort(function (a, b) { return b.n - a.n; });
  }
  function otrosFiltros() { var p = params(), hay = false; p.forEach(function (v, k) { if (k.indexOf('filter.') !== 0 || k === 'filter.p.vendor') return; if (k === 'filter.p.tag' && enGrupo('cat', v)) return; hay = true; }); return hay; }
  function letra(s) { var c = nom(s).charAt(0); return /[A-Z]/.test(c) ? c : '#'; }
  function casas() {
    var act = params().get('filter.p.vendor') || '', m = {};
    (D.casas || []).forEach(function (c) { m[c[0]] = { v: c[0], n: c[1] }; });
    topeCasas = (D.casas || []).length >= 100;
    if (D.dir && topeCasas && D.tipo === 'c' && COMPLETAS.hasOwnProperty(D.handle) && !otrosFiltros()) {
      topeCasas = false;
      var cl = CATL[activo('cat')] || COMPLETAS[D.handle];
      D.dir.split(';').forEach(function (f) { var x = f.split('|'); if (!x[0] || (cl && x[4] !== cl) || m[x[0]]) return; m[x[0]] = { v: x[0], n: Number(x[1]) }; });
    }
    if (act && !m[act]) m[act] = { v: act, n: null };
    return Object.keys(m).map(function (k) { var o = m[k]; o.on = o.v === act; o.k = nom(o.v); return o; }).filter(function (o) { return o.on || o.n === null || o.n > 0; }).sort(function (a, b) {
      var la = letra(a.v), lb = letra(b.v); if (la !== lb) { if (la === '#') return -1; if (lb === '#') return 1; } return a.k < b.k ? -1 : a.k > b.k ? 1 : 0;
    });
  }
  function activos() {
    var p = params(), out = [], v = p.get('filter.p.vendor');
    if (v) out.push({ t: v, a: 'casa', v: '', casa: 1 });
    tags(p).forEach(function (t) { var k = grupoDe(t); if (k === 'cat') return; out.push({ t: k === 'fam' ? famNom(t) : k === 'bq' ? 'En la boutique hoy' : k ? etiqueta(k, t) : t, a: 'quitar', v: t }); });
    if (lte()) out.push({ t: 'Hasta $' + fmt(lte()), a: 'precio', v: '' });
    if (p.get('filter.v.price.gte')) out.push({ t: 'Desde $' + fmt(p.get('filter.v.price.gte')), a: 'param', v: 'filter.v.price.gte' });
    if (p.get('filter.v.availability')) out.push({ t: 'Disponibilidad', a: 'param', v: 'filter.v.availability' });
    return out;
  }
  function ordenes() {
    var lista = ORD_LISTA.filter(function (o) { return (D.ordenes || []).indexOf(o) >= 0; });
    if (D.ordenDef !== 'manual') lista = lista.filter(function (o) { return o !== 'manual'; });
    return lista.map(function (o) { return { v: o, l: ORD[o], on: o === (params().get('sort_by') || D.ordenDef) }; });
  }
  function titulo() {
    var v = params().get('filter.p.vendor'); if (v) return v;
    var c = activo('cat'); if (c) return etiqueta('cat', c);
    if (D.tipo === 's') return D.q ? 'Resultados para “' + D.q + '”' : 'Resultados';
    return D.titulo;
  }

  /* ---------- HTML ---------- */
  function boton(a, v, txt, on, cls, n) { return '<button type="button" class="' + cls + (on ? ' is-on' : '') + '" data-act="' + a + '" data-v="' + esc(v) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' + txt + (n != null ? ' <span class="abx-n">' + fmtN(n) + '</span>' : '') + '</button>'; }
  function chips(a, lista) { return '<div class="abx-chips">' + lista.map(function (o) { return boton(a, o.v, esc(o.l), o.on, 'abx-fchip', o.n); }).join('') + '</div>'; }
  function grupo(t, cuerpo) { return '<div class="abx-g"><p class="abx-g__t">' + t + '</p>' + cuerpo + '</div>'; }
  function preciosHtml() { var act = lte(); return chips('precio', PRECIOS.map(function (v) { return { v: v, l: 'Hasta $' + v, on: act === v, n: null }; })); }
  function bqHtml() { var on = tags().indexOf(BQ) >= 0, n = D.tagMap[BQ] || 0; if (!on && !n) return ''; return '<button type="button" class="abx-bqhoy' + (on ? ' is-on' : '') + '" data-act="bq" data-v="' + BQ + '" aria-pressed="' + on + '"><i aria-hidden="true"></i>En la boutique hoy · ' + fmt(on ? D.total : n) + '</button>'; }
  function gruposHtml(conCat) {
    var h = '', pt = pestanas();
    if (conCat && pt.ver) h += grupo('Categoría', chips('cat', pt.l));
    if (conCat) { var cs = casas(); if (cs.length > 1 || params().get('filter.p.vendor')) h += '<button type="button" class="abx-fila" data-act="hoja" data-v="casas"><span><span class="abx-g__t">Casa</span><span class="abx-fila__v">' + esc(params().get('filter.p.vendor') || 'Casas A–Z') + '</span></span><span class="abx-fila__n">' + fmt(cs.length) + ' casas ›</span></button>'; }
    var f = familias(); if (f.length) h += grupo('Familia olfativa', chips('fam', f));
    var c = opciones('conc'); if (c.length) h += grupo('Concentración', chips('conc', c));
    var g = opciones('gen'); if (g.length) h += grupo('Para quién', chips('gen', g));
    h += grupo('Precio desde 2 ml', preciosHtml());
    var d = opciones('dest'); if (d.length) h += grupo('Destacados', chips('dest', d));
    var b = bqHtml(); if (b) h += '<div class="abx-g abx-g--bq">' + b + '</div>';
    return h;
  }
  function dirHtml(lista) {
    var out = '', letras = [], ult = '';
    lista.forEach(function (c) {
      var l = letra(c.v);
      if (l !== ult) { out += '<p class="abx-dir__l" data-letra="' + l + '">' + l + '</p>'; letras.push(l); ult = l; }
      out += '<button type="button" class="abx-dir__c' + (c.on ? ' is-on' : '') + '" data-act="casa" data-v="' + esc(c.v) + '" data-k="' + esc(c.k) + '" data-l="' + l + '" aria-pressed="' + c.on + '"><span>' + esc(c.v) + '</span>' + (c.n != null ? '<span class="abx-n">' + fmt(c.n) + '</span>' : '') + '</button>';
    });
    if (topeCasas) out += '<p class="abx-dir__nota">Aquí están las 100 casas con más perfumes en esta selección; usa el buscador de la tienda para las demás.</p>';
    return { h: out, letras: letras };
  }
  function letrasHtml(letras, cls) { return letras.map(function (l) { return '<button type="button" class="' + cls + '" data-act="letra" data-v="' + l + '">' + l + '</button>'; }).join(''); }
  function buscadorHtml() { return '<input type="search" class="abx-dir__q" data-abx-qcasa placeholder="Buscar casa…" aria-label="Buscar casa" autocomplete="off" value="' + esc(qCasa) + '">'; }

  function pintarBarra() {
    var el = raiz.querySelector('[data-abx-barra]'); if (!el) return;
    var pt = pestanas(), h = '';
    el.classList.toggle('con-tabs', pt.ver);
    if (pt.ver) {
      h += '<nav class="abx-tabs" aria-label="Categorías" style="--n:' + pt.l.length + '">' + pt.l.map(function (o) {
        return '<button type="button" class="abx-tab' + (o.on ? ' is-on' : '') + '" data-act="cat" data-v="' + o.v + '" aria-pressed="' + o.on + '"><span class="abx-tab__l">' + o.l + '</span><span class="abx-tab__n">' + (o.n != null ? fmtN(o.n) : '&nbsp;') + '</span></button>';
      }).join('') + '</nav>';
    }
    var ac = activos().filter(function (a) { return !a.casa; }).length, v = params().get('filter.p.vendor'), f = familias(), nf = f.filter(function (x) { return x.on; }).length, pr = lte();
    var ord = ordenes().filter(function (o) { return o.on; })[0];
    var cb = function (hojaV, txt, on, flecha) { return '<button type="button" class="abx-cb' + (on ? ' is-on' : '') + '" data-act="hoja" data-v="' + hojaV + '"><span class="abx-cb__t">' + txt + '</span>' + flecha + '</button>'; };
    var abajo = '<span class="abx-cb__f" aria-hidden="true">▾</span>', ambas = '<span class="abx-cb__f abx-cb__f--2" aria-hidden="true"><svg viewBox="0 0 15 32" focusable="false"><path d="M0 13 7.5 0 15 13z"/><path d="M0 19h15L7.5 32z"/></svg></span>';
    var bs = [];
    if (D.filtros) {
      bs.push(cb('filtros', ac ? 'Filtros · ' + ac : 'Filtros', ac, ''));
      if (casas().length > 1 || v) bs.push(cb('casas', esc(v || 'Casas'), v, abajo));
      if (f.length) bs.push(cb('fam', nf ? 'Familia · ' + nf : 'Familia', nf, abajo));
      bs.push(cb('precio', pr ? 'Hasta $' + fmt(pr) : 'Precio', pr, abajo));
    }
    if (ordenes().length > 1) bs.push(cb('orden', 'Ordenar', ord && ord.v !== D.ordenDef, ambas));
    h += '<div class="abx-col__chips" style="--nc:' + Math.max(1, bs.length) + '">' + bs.join('') + '</div>';
    el.innerHTML = h;
  }
  function pintarInfo() {
    var el = raiz.querySelector('[data-abx-info]'); if (!el) return;
    var h = '', os = ordenes(), ac = activos();
    h += '<div class="abx-col__ord">' + (os.length > 1 ? '<span class="abx-g__t">Ordenar</span>' + os.map(function (o) { return boton('orden', o.v, o.l, o.on, 'abx-ob'); }).join('') : '') + vistasHtml() + '</div>';
    h += '<div class="abx-col__fila"><div class="abx-col__act">' + (ac.length ? ac.map(function (a) { return '<button type="button" class="abx-ac" data-act="' + a.a + '" data-v="' + esc(a.v) + '">' + esc(a.t) + ' ✕</button>'; }).join('') + '<button type="button" class="abx-ac-l" data-act="limpiar">Limpiar filtros</button>' : '') + '</div>' + vistasHtml() + '</div>';
    el.innerHTML = h;
  }
  function pintarLado() {
    var el = raiz.querySelector('[data-abx-lado]'); if (!el) return;
    if (!mqD.matches || !D.filtros) { if (el.innerHTML) el.innerHTML = ''; el.hidden = !D.filtros; return; }
    el.hidden = false;
    var dirEl = el.querySelector('.abx-lado__dir'), sc = dirEl ? dirEl.scrollTop : 0;
    var cs = casas(), dh = dirHtml(cs), h = '', pt = pestanas();
    if (pt.ver) h += grupo('Categoría', chips('cat', pt.l));
    if (cs.length > 1 || params().get('filter.p.vendor')) {
      h += '<div class="abx-g"><div class="abx-lado__cab"><p class="abx-g__t">Casas A–Z · ' + fmt(cs.length) + '</p>' + (params().get('filter.p.vendor') ? '<button type="button" class="abx-lado__todas" data-act="casa" data-v="">Todas</button>' : '') + '</div>' + buscadorHtml() + '<div class="abx-lado__letras">' + letrasHtml(dh.letras, 'abx-lado__l') + '</div><div class="abx-dir abx-lado__dir">' + dh.h + '</div></div>';
    }
    h += gruposHtml(false);
    el.innerHTML = h;
    var nd = el.querySelector('.abx-lado__dir'); if (nd) { nd.scrollTop = sc; filtrarCasas(el); }
  }
  function pintarHoja() {
    if (!hojaEl) return;
    if (!hoja) { hojaEl.hidden = true; hojaEl.innerHTML = ''; hojaPintada = ''; return; }
    var mismo = hojaPintada === hoja, selC = hoja === 'casas' ? '.abx-dir' : '.abx-hoja__cuerpo', cuerpoViejo = mismo ? hojaEl.querySelector(selC) : null, sc = cuerpoViejo ? cuerpoViejo.scrollTop : 0;
    hojaPintada = hoja;
    var cab = '', cuerpo = '', pie = '', cls = '', ver = raiz.classList.contains('is-cargando') ? 'Buscando…' : 'Ver ' + perf(D.total);
    var cerrar = '<button type="button" class="abx-hoja__x" data-act="cerrar" aria-label="Cerrar">✕</button>';
    if (hoja === 'filtros') {
      cab = '<h2>Filtros</h2>'; cuerpo = gruposHtml(true);
      pie = '<button type="button" class="abx-hoja__l" data-act="limpiar">Limpiar</button><button type="button" class="abx-hoja__ver" data-act="cerrar">' + ver + '</button>';
    } else if (hoja === 'casas') {
      var cs = casas(), dh = dirHtml(cs), cat = activo('cat');
      cls = ' abx-hoja--casas';
      cab = '<div><p class="abx-hoja__k">' + esc(cat ? etiqueta('cat', cat) : titulo()) + '</p><h2>Casas de la A a la Z</h2></div>';
      cuerpo = '<div class="abx-hoja__dirw">' + buscadorHtml() + '<div class="abx-hoja__alfa" role="navigation" aria-label="Ir a la letra">' + letrasHtml(dh.letras, 'abx-hoja__rl') + '</div><div class="abx-dir"><button type="button" class="abx-dir__c abx-dir__todas' + (params().get('filter.p.vendor') ? '' : ' is-on') + '" data-act="casa" data-v=""><span>Todas las casas</span><span class="abx-n">' + fmt(cs.length) + '</span></button>' + dh.h + '</div></div>';
    } else if (hoja === 'fam') {
      cab = '<h2>¿Qué se te antoja?</h2>'; cuerpo = chips('fam', familias());
      pie = '<button type="button" class="abx-hoja__ver" data-act="cerrar">' + ver + '</button>';
    } else if (hoja === 'precio') {
      cab = '<h2>Precio desde 2 ml</h2>'; cuerpo = preciosHtml();
      pie = '<button type="button" class="abx-hoja__ver" data-act="cerrar">' + ver + '</button>';
    } else if (hoja === 'orden') {
      cab = '<h2>Ordenar</h2>'; cuerpo = ordenes().map(function (o) { return boton('orden', o.v, o.l, o.on, 'abx-hoja__o'); }).join('');
    }
    var dentro = '<div class="abx-hoja__cab">' + cab + cerrar + '</div><div class="abx-hoja__cuerpo">' + cuerpo + '</div>' + (pie ? '<div class="abx-hoja__pie">' + pie + '</div>' : '');
    /* misma hoja abierta: solo se cambia el contenido; el panel no se vuelve a crear, así no repite la animación de entrada en cada recarga */
    var panel = mismo ? hojaEl.querySelector('.abx-hoja__panel') : null;
    if (panel) { panel.className = 'abx-hoja__panel' + cls; panel.innerHTML = dentro; }
    else hojaEl.innerHTML = '<div class="abx-hoja__fondo" data-act="cerrar"></div><div class="abx-hoja__panel' + cls + '" role="dialog" aria-modal="true">' + dentro + '</div>';
    hojaEl.hidden = false;
    var nc = hojaEl.querySelector(selC); if (nc) nc.scrollTop = sc;
    if (hoja === 'casas') filtrarCasas(hojaEl);
  }
  function pintar() { if (!D) return; raiz.classList.toggle('abx-sin-lado', !D.filtros); pintarBarra(); pintarInfo(); pintarLado(); pintarHoja(); }

  function filtrarCasas(caja) {
    var q = nom(qCasa.trim());
    caja.querySelectorAll('.abx-dir__c[data-k]').forEach(function (b) { b.hidden = !!q && b.getAttribute('data-k').indexOf(q) < 0; });
    caja.querySelectorAll('.abx-dir__l').forEach(function (p) { var l = p.getAttribute('data-letra'); p.hidden = !!q && !caja.querySelector('.abx-dir__c[data-l="' + l + '"]:not([hidden])'); });
    caja.querySelectorAll('.abx-hoja__rl').forEach(function (b) { var l = b.getAttribute('data-v'); b.hidden = !!q && !caja.querySelector('.abx-dir__c[data-l="' + l + '"]:not([hidden])'); });
  }
  function saltar(btn, l) {
    var caja = btn.closest('.abx-hoja__panel, .abx-col__lado'); if (!caja) return;
    var lista = caja.querySelector('.abx-dir'), el = lista && lista.querySelector('[data-letra="' + l + '"]');
    if (el) lista.scrollTop = el.offsetTop - 4;
  }
  function abrir(v) {
    if (hoja === v) return;
    if (v !== 'casas') qCasa = '';
    hoja = v; pintarHoja();
    document.documentElement.classList.add('abx-hoja-abierta');
  }
  function cerrarQuieto() { hoja = ''; qCasa = ''; subirAlCerrar = false; pintarHoja(); document.documentElement.classList.remove('abx-hoja-abierta'); }
  function cerrar() {
    hoja = ''; qCasa = ''; pintarHoja();
    document.documentElement.classList.remove('abx-hoja-abierta');
    if (subirAlCerrar) { subirAlCerrar = false; arriba(); }
    else if (window.scrollY > objetivo() + 4) arriba();
  }

  /* ---------- eventos ---------- */
  function alClic(e) {
    var pag = e.target.closest('a[data-abx-pag]');
    if (pag && raiz.contains(pag)) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      e.preventDefault(); var u = new URL(pag.getAttribute('href'), location.origin); u.searchParams.delete('section_id');
      cargar(u.pathname + u.search, true, true); return;
    }
    var b = e.target.closest('[data-act]'); if (!mio(b) || !D) return;
    var a = b.getAttribute('data-act'), v = b.getAttribute('data-v') || '';
    switch (a) {
      case 'cat': case 'conc': case 'gen': case 'dest': radio(a, v); break;
      case 'fam': case 'bq': case 'quitar': alternar(v); break;
      case 'casa': if (hoja) cerrarQuieto(); casa(v); break;
      case 'precio': precio(v); break;
      case 'orden': if (hoja === 'orden') cerrarQuieto(); orden(v); break;
      case 'param': quitarParam(v); break;
      case 'limpiar': limpiar(); break;
      case 'hoja': abrir(v); break;
      case 'cerrar': cerrar(); break;
      case 'letra': saltar(b, v); break;
      case 'vista': ponerVista(v); break;
    }
  }
  function alEscribir(e) {
    var q = e.target.closest('[data-abx-qcasa]'); if (!q) return;
    qCasa = q.value; filtrarCasas(q.closest('.abx-hoja__panel, .abx-col__lado') || raiz);
  }
  function alTecla(e) { if (e.target.closest('[data-abx-qcasa]') && e.key === 'Enter') e.preventDefault(); }
  [raiz, hojaEl].forEach(function (el) { if (!el) return; el.addEventListener('click', alClic); el.addEventListener('input', alEscribir); el.addEventListener('keydown', alTecla); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && hoja) cerrar(); });
  window.addEventListener('popstate', function () { if (location.pathname === RUTA) { if (hoja) cerrarQuieto(); cargar(location.href, false, false); } });
  var alCambiar = function () { vista(); pintar(); };
  if (mqD.addEventListener) { mqD.addEventListener('change', alCambiar); mqT.addEventListener('change', alCambiar); }

  D = leer();
  if (!D) return;
  try { history.replaceState({ abxCol: 1 }, ''); } catch (e) {}
  vista(); limpiarLigas(); pintar(); extras(); medir();
})();